/* eslint-disable no-undef */
// import { chartingMapping } from './charting-utils.js';

window.Wized = window.Wized || [];
window.Wized.push(async (Wized) => {
  const sessionInfo = await Wized.requests.waitFor('get_session');
  // if (sessionId !== sessionInfo.data.id) {
  // sessionStorage.clear();
  // sessionStorage.setItem('sessionId', sessionInfo.data.id);
  // }
  // let videoStartTime = 0;
  const sessionValidTime = 30;
  // const mediaValidTime = 1.5;
  let sessionStartTime = new Date(sessionInfo.data.created_at);

  const updatePages = (tabIndex, pageIndex, subPageIndex) => {
    const numTabIndex = parseInt(tabIndex);
    const numPageIndex = parseInt(pageIndex);
    const numSubPageIndex = parseInt(subPageIndex);
    currentTabIndex = numTabIndex;
    currentPageIndex = numPageIndex;
    currentSubpageIndex = numSubPageIndex;
    showTab(numTabIndex);
    showPage(numPageIndex, numSubPageIndex); // Add currentSubpageIndex here
    updateProgress();
    updateButtonsVisibility();
  };

  sessionStorage.setItem('sessionId', sessionInfo.data.id);
  sessionStorage.setItem('sessionStartTime', sessionStartTime);
  const now = new Date();

  // const sessionMediaTimeStamp = sessionStorage.getItem('sessionMediaTimeStamp');
  // const sessionMediaStartTime = sessionStorage.getItem('sessionMediaStartTime');
  // const sessionMediaTabIndex = sessionStorage.getItem('sessionMediaTabIndex');
  // const sessionMediaPageIndex = sessionStorage.getItem('sessionMediaPageIndex');
  // const sessionMediaSubpageIndex = sessionStorage.getItem('sessionMediaSubpageIndex');
  const diffInMs = now - sessionStartTime;
  const diffInMinutes = diffInMs / (1000 * 60);

  // const diffInMsMedia = now - sessionMediaStartTime;
  // const diffInMinutesMedia = diffInMsMedia / (1000 * 60);

  if (diffInMinutes < sessionValidTime) {
    const finishedPreSession = sessionStorage.getItem('finishedPreSession');
    if (finishedPreSession) {
      const tabIndex = sessionStorage.getItem('readyPageTabIndex');
      const pageIndex = sessionStorage.getItem('readyPagePageIndex');
      const subPageIndex = sessionStorage.getItem('readyPageSubPageIndex');
      calm_meta = sessionStorage.getItem('calmMetaData');
      updatePages(tabIndex, pageIndex, subPageIndex);
      // if (sessionMediaStartTime) {
      //   if (diffInMinutesMedia < mediaValidTime) {
      //     videoStartTime = sessionMediaTimeStamp;
      //     updatePages(sessionMediaTabIndex, sessionMediaPageIndex, sessionMediaSubpageIndex);
      //   } else {
      //     console.log('they started media but are not within 90 seconds');
      //     updatePages(0, 0, 8);
      //   }
      // } else {
      //   console.log('they havenot started the video yet, putting them on ready')
      //   console.log(sessionStorage)
      //   updatePages(0, 0, 8);
      // }
    } else {
      console.log('they didnt finish presession');
      // if (finishedPreSession) {
      //   console.log('putting them on the ready page')
      //   // const readyTabIndex = sessionStorage.getItem('readyPageTabIndex');
      //   // const readyPageIndex = sessionStorage.getItem('readyPagePageIndex');
      //   // const readySubpageIndex = sessionStorage.getItem('readyPageSubpageIndex');
      //   // updatePages(0, 0, 8);
      // } else {
      //   // updatePages(0, 0, 8);
      // }
    }
  } else {
    sessionStorage.clear();
    console.log('it has been longer than 30 mins');
  }

  // updatePages(currentTabIndex, currentPageIndex, currentSubpageIndex);

  //Charting Elements
  let chartClicks = 0;
  let startPoint = document.getElementById('startPoint');
  let endPoint = document.getElementById('endPoint');
  let finalStartPoint = document.getElementById('finalStartPoint');
  let finalEndPoint = document.getElementById('finalEndPoint');
  let finalPoint = document.getElementById('finalPoint');
  let startChartLine = document.getElementById('startChartLine');
  let finalChartLine = document.getElementById('finalChartLine');
  let chartingSessionComplete = false;
  const chartResetButton = document.getElementById('chartReset');
  const finalChartResetButton = document.getElementById('finalChartReset');
  const tabletInput = document.querySelector('[data-name="tablet_number_input"]');
  chartResetButton.style.display = 'none'; // initially don't display reset button
  finalChartResetButton.style.display = 'none'; // initially don't display reset button
  let playlistFinished = false;
  var selectedPlaylist = null;
  var endStateCategory = null;
  var calm_meta = {
    start: {
      val: null,
      aro: null,
      quad: null,
    },
    end: {
      val: null,
      aro: null,
      quad: null,
    },
    final: {
      val: null,
      aro: null,
      quad: null,
    },
    stimuli: {
      endstate: null, //calm
      category: null, //classical
      type: null, // abilene
      name: null, //playlist name (abilene 15 min)
      files: null, //playlist files
    },
    sessionType: null,
    tabletNumber: null,
  };

  const chartingWrappers = document.querySelectorAll('.charting_plus-grid');

  chartingWrappers.forEach((chartWrapper) => {
    for (let i = 0; i < 19; i++) {
      for (let j = 0; j < 19; j++) {
        // Create the grid item container
        const gridItem = document.createElement('div');

        let quad;

        if (i >= 10 && j < 10) {
          quad = '3'; // Bottom-left quad
        } else if (i >= 10 && j >= 10) {
          quad = '4'; // Bottom-right quad
        } else if (i < 10 && j < 10) {
          quad = '1'; // Top-left quad
        } else if (i < 10 && j >= 10) {
          quad = '2'; // Top-right quad
        }

        // Set the quadrant attribute
        // gridItem.setAttribute("quadrant", quadrant);
        const val = j + 1; // Column number
        const aro = 19 - i; // Row number

        // If it's the very center div (intersection of the center row and center column)
        if (i === 9 && j === 9) {
          gridItem.setAttribute('val', val);
          gridItem.setAttribute('aro', aro);

          gridItem.classList.add('charting_plus-grid-split', 'is-center');

          const gridItemTopLeft = document.createElement('div');
          const gridItemTopRight = document.createElement('div');
          const gridItemBottomLeft = document.createElement('div');
          const gridItemBottomRight = document.createElement('div');

          gridItemTopLeft.setAttribute('val', val);
          gridItemTopLeft.setAttribute('aro', aro);
          gridItemTopLeft.setAttribute('quad', '1');

          gridItemTopRight.setAttribute('val', val);
          gridItemTopRight.setAttribute('aro', aro);
          gridItemTopRight.setAttribute('quad', '2');

          gridItemBottomLeft.setAttribute('val', val);
          gridItemBottomLeft.setAttribute('aro', aro);
          gridItemBottomLeft.setAttribute('quad', '3');

          gridItemBottomRight.setAttribute('val', val);
          gridItemBottomRight.setAttribute('aro', aro);
          gridItemBottomRight.setAttribute('quad', '4');

          gridItemTopLeft.classList.add('charting_plus-grid-item');
          gridItemTopRight.classList.add('charting_plus-grid-item');
          gridItemBottomLeft.classList.add('charting_plus-grid-item');
          gridItemBottomRight.classList.add('charting_plus-grid-item');

          gridItem.appendChild(gridItemTopLeft);
          gridItem.appendChild(gridItemTopRight);
          gridItem.appendChild(gridItemBottomLeft);
          gridItem.appendChild(gridItemBottomRight);

          // gridItem.appendChild(gridContainer);

          chartWrapper.appendChild(gridItem);
        } else if (i === 9) {
          // If it's on the center row (X-axis), split the div into top and bottom
          gridItem.classList.add('charting_plus-grid-split', 'is-horzontal');

          const gridItemTop = document.createElement('div');
          const gridItemBottom = document.createElement('div');

          gridItemTop.classList.add('charting_plus-grid-item');
          gridItemBottom.classList.add('charting_plus-grid-item');

          gridItemTop.setAttribute('val', val);
          gridItemTop.setAttribute('aro', aro);

          gridItemBottom.setAttribute('val', val);
          gridItemBottom.setAttribute('aro', aro);

          if (j < 10) {
            gridItemTop.setAttribute('quad', '1');
            gridItemBottom.setAttribute('quad', '3');
          }

          if (j >= 10) {
            gridItemTop.setAttribute('quad', '2');
            gridItemBottom.setAttribute('quad', '4');
          }

          gridItem.appendChild(gridItemTop);
          gridItem.appendChild(gridItemBottom);

          chartWrapper.appendChild(gridItem);
        } else if (j === 9) {
          // If it's on the center column (Y-axis), split the div into left and right
          gridItem.classList.add('charting_plus-grid-split');

          const gridItemLeft = document.createElement('div');
          const gridItemRight = document.createElement('div');

          gridItemLeft.classList.add('charting_plus-grid-item');
          gridItemRight.classList.add('charting_plus-grid-item');

          gridItemLeft.setAttribute('val', val);
          gridItemLeft.setAttribute('aro', aro);

          gridItemRight.setAttribute('val', val);
          gridItemRight.setAttribute('aro', aro);

          if (i < 10) {
            gridItemLeft.setAttribute('quad', '1');
            gridItemRight.setAttribute('quad', '2');
          }

          if (i >= 10) {
            gridItemLeft.setAttribute('quad', '3');
            gridItemRight.setAttribute('quad', '4');
          }

          gridItem.appendChild(gridItemLeft);
          gridItem.appendChild(gridItemRight);

          // gridItem.appendChild(gridContainer);

          chartWrapper.appendChild(gridItem);
        } else {
          // Normal grid item (not on the center row/column)
          gridItem.classList.add('charting_plus-grid-item');
          gridItem.setAttribute('quad', quad);
          gridItem.setAttribute('val', val);
          gridItem.setAttribute('aro', aro);

          chartWrapper.appendChild(gridItem);
        }
      }
    }
  });
  let calmQuadrant = document.querySelector('[val="14"][aro="5"]');

  //Charting Functions
  tabletInput.addEventListener('input', (e) => {
    calm_meta.tabletNumber = e.target.value;
  });

  const resetStartGrid = () => {
    chartClicks = 0;
    startChartLine.innerHTML = '';
    chartResetButton.style.display = 'none';
    startPoint.style.display = 'none';
    endPoint.style.display = 'none';
    document.querySelectorAll("[quad='1']").forEach(function (element) {
      element.style.pointerEvents = 'auto';
    });
    document.querySelectorAll("[quad='3']").forEach(function (element) {
      element.style.pointerEvents = 'auto';
    });
    disableContinueButton();
  };

  const resetEndGrid = () => {
    chartClicks = 2;
    chartResetButton.style.display = 'none';
    finalPoint.style.display = 'none';
    finalChartResetButton.style.display = 'none';
    disableContinueButton();
  };

  const drawLine = (startPoint, endPoint, chartLine) => {
    chartLine.innerHTML = '';
    let line = document.createElementNS('http://www.w3.org/2000/svg', 'line');
    line.setAttribute('x1', startPoint.style.left);
    line.setAttribute('y1', startPoint.style.top);
    line.setAttribute('x2', endPoint.style.left);
    line.setAttribute('y2', endPoint.style.top);
    line.setAttribute('stroke', '#E7E1D1');
    line.setAttribute('stroke-width', '2');
    chartLine.appendChild(line);
  };

  // general functionality

  function getElementPosition(element) {
    if (!element) return null;

    const rect = element.getBoundingClientRect();

    return {
      x: rect.left + rect.width / 2,
      y: rect.top + rect.height / 2,
    };
  }

  const gridPoints = document.querySelectorAll('.charting_plus-grid-item');
  gridPoints.forEach((gridPoint) => {
    gridPoint.addEventListener('click', async function (event) {
      const calmQuadrantPosition = getElementPosition(calmQuadrant);
      if (chartClicks !== 3) {
        chartClicks += 1;
      }
      let parentRect;
      if (event.currentTarget.parentElement.classList[0] === 'charting_plus-grid-split') {
        parentRect = event.currentTarget.parentElement.parentElement.getBoundingClientRect();
      } else {
        parentRect = event.currentTarget.parentElement.getBoundingClientRect();
      }
      let x = event.clientX - parentRect.left;
      let y = event.clientY - parentRect.top;
      if (chartClicks === 1) {
        disableContinueButton();
        startPoint.style.display = 'block';
        startPoint.style.left = x + 'px';
        startPoint.style.top = y + 'px';
        startPoint.style.zIndex = '2';
        endPoint.style.display = 'block';
        endPoint.style.left = calmQuadrantPosition.x - parentRect.left + 'px';
        endPoint.style.top = calmQuadrantPosition.y - parentRect.top + 'px';
        endPoint.style.zIndex = '1';
        endPoint.classList.add('is-selected');
        calm_meta.start.val = gridPoint.getAttribute('val');
        calm_meta.start.aro = gridPoint.getAttribute('aro');
        calm_meta.start.quad = gridPoint.getAttribute('quad');
        calm_meta.end.val = calmQuadrant.getAttribute('val');
        calm_meta.end.aro = calmQuadrant.getAttribute('aro');
        calm_meta.end.quad = calmQuadrant.getAttribute('quad');
        chartResetButton.style.display = 'block';
        // disableGrids();
        drawLine(startPoint, endPoint, startChartLine);
        enableContinueButton();

        // final start point styling
        finalStartPoint.style.left = startPoint.style.left;
        finalStartPoint.style.top = startPoint.style.top;
        finalStartPoint.style.zIndex = startPoint.style.zIndex;
        finalStartPoint.style.display = 'block';
        finalStartPoint.style.opacity = '0.40';

        // final end point styling
        finalEndPoint.style.left = endPoint.style.left;
        finalEndPoint.style.top = endPoint.style.top;
        finalEndPoint.style.zIndex = endPoint.style.zIndex;
        finalEndPoint.style.display = 'block';
        finalEndPoint.style.opacity = '0.40';
        finalChartLine.style.opacity = '0.50';

        sessionStorage.setItem('finalStartPointLeft', startPoint.style.left);
        sessionStorage.setItem('finalStartPointTop', startPoint.style.top);
        sessionStorage.setItem('finalStartPointZIndex', startPoint.style.zIndex);
        sessionStorage.setItem('finalEndPointLeft', endPoint.style.left);
        sessionStorage.setItem('finalEndPointTop', endPoint.style.top);
        sessionStorage.setItem('finalEndPointZIndex', endPoint.style.zIndex);

        drawLine(finalStartPoint, finalEndPoint, finalChartLine);
        chartingSessionComplete = true;
        chartClicks = 2;
      }
      if (chartingSessionComplete && playlistFinished && chartClicks === 3) {
        finalPoint.style.display = 'block';
        finalPoint.style.left = x + 'px';
        finalPoint.style.top = y + 'px';
        finalPoint.style.zIndex = '2';
        calm_meta.final.val = gridPoint.getAttribute('val');
        calm_meta.final.aro = gridPoint.getAttribute('aro');
        calm_meta.final.quad = gridPoint.getAttribute('quad');
        finalChartResetButton.style.display = 'block';
        enableContinueButton();
      }
    });
  });

  chartResetButton.addEventListener('click', async () => {
    resetStartGrid();
  });

  finalChartResetButton.addEventListener('click', async () => {
    resetEndGrid();
  });

  // end charting logic

  // timer logic
  let timeLeft = 300; // 5 mins
  let timerActive = false;
  let countdownInterval;
  let timer = document.querySelector('[data-name="calm_timer"]');
  const timerWrapper = document.querySelector('[data-name="timer_wrapper"]');
  timerWrapper.classList.add('hide');
  timer.textContent = '5:00';

  function onTimerEnd() {
    timerActive = false;
    // Dispatch a custom event
    const event = new Event('timerFinished');
    document.dispatchEvent(event);
  }

  function resetCountdown() {
    clearInterval(countdownInterval);
    timeLeft = 300;
    timer.innerText = '5:00';
  }
  resetCountdown();

  function startCountdown() {
    timerActive = true;
    resetCountdown();
    countdownInterval = setInterval(() => {
      if (timeLeft < 0) {
        clearInterval(countdownInterval);
        onTimerEnd();
      } else {
        let minutes = Math.floor(timeLeft / 60);
        let seconds = timeLeft % 60;
        timer.textContent = `${minutes}:${seconds.toString().padStart(2, '0')}`;
        timeLeft--;
      }
    }, 1000);
  }

  document.addEventListener('start-pre-timer', async function () {
    timerWrapper.classList.remove('hide');
    startCountdown();
  });

  document.addEventListener('end-pre-timer', async function () {
    if (timerActive) {
      disableContinueButton();
      // Added Once so it only fires once.
      document.addEventListener(
        'timerFinished',
        async function () {
          enableContinueButton();
          resetCountdown();
          timerWrapper.classList.add('hide');
        },
        { once: true }
      );
    } else {
      enableContinueButton();
      timerWrapper.classList.add('hide');
    }
  });

  document.addEventListener('start-post-timer', async function () {
    timerWrapper.classList.remove('hide');
    startCountdown();
  });
  document.addEventListener('end-post-timer', async function () {
    if (timerActive) {
      disableContinueButton();
      // Added Once so it only fires once.
      document.addEventListener(
        'timerFinished',
        async function () {
          enableContinueButton();
          resetCountdown();
          timerWrapper.classList.add('hide');
        },
        { once: true }
      );
    } else {
      enableContinueButton();
      timerWrapper.classList.add('hide');
    }
  });

  // media logic

  const previewAudioPlayer = document.querySelector('[data-name="preview_audio_player"]');
  const previewVideoPlayer = document.querySelector('[data-name="preview_video"]');
  const previewVideoModal = document.querySelector('[data-name="video_modal_wrapper"]');
  const modalCloseButton = document.querySelector('[data-name="modal_close_button"]');
  modalCloseButton.addEventListener('click', () => {
    closeVideoPreviewModal();
  });
  const sectionContent = document.querySelector('.section_content');
  const sectionHeader = document.querySelector('.section_header');
  const sectionFooter = document.querySelector('.section_footer');

  previewAudioPlayer.style.display = 'none';

  // playlist functionality
  const user = await Wized.requests.waitFor('get_user');
  const userAdmin = user.data.is_admin;

  const playlistCategories = user.data.study_group.media.calm[0].category_items;
  let selectedFiles = null;
  let currentPreviewMedia = null;
  let currentPreviewButton = null;

  // div where all playlist categories go
  const playlistsContainer = document.querySelector('[data-name="playlist-categories-component"]');

  // get the templates and clone them
  const playlistCategoryTemplate = document.getElementsByTagName('template')[0];
  const playlistItemTemplate = document.getElementsByTagName('template')[1];

  const handleAudioPreviewMedia = (playlist, button) => {
    let id = button.getAttribute('playlist-id');
    let currentId = currentPreviewButton?.getAttribute('playlist-id') ?? null;
    if (currentPreviewMedia && id !== currentId) {
      previewAudioPlayer.pause();
      previewAudioPlayer.currentTime = 0;
      currentPreviewButton.textContent = 'Preview';
    }

    if (currentPreviewMedia && id === currentId) {
      if (previewAudioPlayer.paused) {
        previewAudioPlayer.play();
        button.textContent = 'Stop';
      } else if (!previewAudioPlayer.paused) {
        previewAudioPlayer.pause();
        button.textContent = 'Preview';
      }
    } else {
      [currentPreviewMedia] = playlist.files;
      previewAudioPlayer.src = currentPreviewMedia.preview_url;
      previewAudioPlayer.play();
      currentPreviewButton = button;
      button.textContent = 'Stop';
    }
  };

  const closeVideoPreviewModal = () => {
    previewVideoModal.style.display = 'none';
    sectionContent.style.overflow = 'scroll';
    previewVideoPlayer.src = '';
    if (sectionFooter) sectionFooter.style.zIndex = '2';
    if (sectionHeader) sectionHeader.style.zIndex = '2';
  };

  const openVideoPreviewModal = (videoTitle) => {
    previewVideoModal.style.display = 'block';
    sectionContent.style.overflow = 'hidden'; // Disable overflow

    document.querySelector('[data-name="video_preview_title"]').textContent = videoTitle;
    if (sectionHeader) sectionHeader.style.zIndex = '0';
    if (sectionFooter) sectionFooter.style.zIndex = '0';
  };

  const handleVideoPreviewMedia = (playlist, button) => {
    let videoTitle = playlist.files[0].title;
    [currentPreviewMedia] = playlist.files;
    previewVideoPlayer.src = currentPreviewMedia.preview_url;
    openVideoPreviewModal(videoTitle);
    previewVideoPlayer.play();
    currentPreviewButton = button;
  };

  const audioPlayer = document.querySelector('[data-name="session_audio_player"]');
  const audioPlayerWrapper = document.querySelector('[data-name="audio_wrapper"]');
  const videoPlayer = document.querySelector('[data-name="session_video"]');
  let videoPlyr = {};
  if (userAdmin) {
    videoPlyr = new Plyr('[data-name="session_video"]');
    new Plyr(audioPlayer);
  } else {
    videoPlyr = new Plyr('[data-name="session_video"]', {
      controls: ['play', 'fullscreen'],
    });
    new Plyr(audioPlayer, {
      controls: ['play'],
    });
  }

  const playCurrentFile = (currentPlaylistFiles) => {
    if (currentIndex >= currentPlaylistFiles.length) {
      return;
    }
    const file = currentPlaylistFiles[currentIndex];
    document.querySelector('[data-name="session_audio_title"]').textContent = file.title;
    document.querySelector('[data-name="session_audio_artist"]').textContent = file.artist;
    if (file.type === 'mixed') {
      audioPlayer.src = file.audio_url;
      videoPlayer.src = file.video_url;
      audioPlayer.style.display = 'none';
      videoPlayer.style.display = 'block';

      loadMedia(currentIndex, audioPlayer);
      loadMedia(currentIndex, videoPlayer);

      videoPlayer.onplay = () => {
        if (audioPlayer.paused) {
          audioPlayer.play();
        }
      };

      videoPlayer.onpause = () => {
        if (!audioPlayer.paused) {
          audioPlayer.pause();
        }
      };

      videoPlayer.onvolumechange = () => {
        audioPlayer.volume = videoPlayer.volume;
      };

      videoPlayer.ontimeupdate = () => {
        if (Math.abs(videoPlayer.currentTime - audioPlayer.currentTime) > 0.1) {
          audioPlayer.currentTime = videoPlayer.currentTime;
        }
      };
      videoPlayer.onended = () => playNextFile(currentPlaylistFiles, videoPlyr);
    } else if (file.type === 'audio') {
      audioPlayer.src = file.audio_url;
      audioPlayer.style.display = 'block';
      videoPlayer.style.display = 'none';
      loadMedia(currentIndex, audioPlayer);

      audioPlayer.onended = () => playNextFile(currentPlaylistFiles, videoPlyr);
    } else if (file.type === 'video') {
      videoPlayer.src = file.video_url;
      videoPlayer.style.display = 'block';
      audioPlayerWrapper.style.display = 'none';
      // videoPlayer.currentTime = videoStartTime;
      // videoPlayer.onplay = () => {
      //   sessionStorage.setItem('sessionMediaStartTime', now);
      //   console.log('now media start time', now);
      // };
      // videoPlayer.ontimeupdate = () => {
      //   sessionStorage.setItem('sessionMediaTimeStamp', videoPlayer.currentTime);
      //   console.log(sessionStorage.getItem('sessionMediaTimeStamp'));
      // };

      loadMedia(currentIndex, videoPlayer);
      videoPlayer.onended = () => playNextFile(currentPlaylistFiles, videoPlyr);
    }
  };

  let currentIndex = 0;

  const loadPlaylist = (files) => {
    const currentPlaylist = files;
    currentIndex = 0;
    playCurrentFile(currentPlaylist);
  };

  const createPlaylistItems = (playlistCategoryContainer, playlistCategories, category) => {
    const playlists = playlistCategories
      .map((category) => {
        return category.playlist;
      })
      .flat(Infinity);
    playlists.forEach((playlist) => {
      const playlistItem = playlistItemTemplate.content.cloneNode(true);
      playlistItem
        .querySelector('[data-name="whole_playlist_item"]')
        .setAttribute('playlist-id', playlist.id);
      if (playlist.files.length > 0) {
        if (playlist.playlist_type === 'visual') {
          if (playlist.files.length === 1) {
            playlistItem
              .querySelector('[data-name="thumbnail-image-container"]')
              .classList.add('is-single');
          }
          playlistItem
            .querySelector('[data-name="thumbnail-image-container"]')
            .classList.add('is-visual');
          if (!playlist.guidance) {
            playlistItem.querySelector('[data-name="guidance"]').classList.add('hide');
          }
        }
        playlistItem.querySelector('[data-name="playlist-thumbnail-image"]').src =
          playlist.playlist_thumbnail.url;
        playlistItem.querySelector('[data-name="playlist-title"]').textContent =
          playlist.playlist_name;
        playlistItem
          .querySelector('[data-name="playlist-thumbnail-image"]')
          .setAttribute('playlist-id', playlist.id);
        playlistItem
          .querySelector('[data-name="playlist-thumbnail-image"]')
          .addEventListener('click', function () {
            const parentContainer = this.closest('.thumbnail_component');
            let playlistId = parentContainer.getAttribute('playlist-id');
            if (playlist.id === playlistId) {
              selectedFiles = playlist.files;
            }
            selectedPlaylist = playlist;
            endStateCategory = category;
            loadPlaylist(selectedFiles);
          });
        const previewButton = playlistItem.querySelector('[data-name="preview_stimuli"]');
        previewButton.setAttribute('playlist-id', playlist.id);
        previewButton.addEventListener('click', function () {
          if (playlist.files[0].type === 'audio') {
            handleAudioPreviewMedia(playlist, this);
          } else {
            handleVideoPreviewMedia(playlist, this);
          }
        });
        playlistCategoryContainer.appendChild(playlistItem);
      }
    });
  };

  const renderPlaylistCategories = () => {
    playlistCategories.forEach((category) => {
      const playlistCategory = playlistCategoryTemplate.content.cloneNode(true);
      const playlistContainer = playlistCategory.querySelector('[data-name="playlist_container"]');
      playlistCategory.querySelector('[data-name="playlist_type"]').textContent =
        category.category_item_name;
      playlistCategory.querySelector('[data-name="playlist_info"]').textContent =
        category.category_item_info;
      createPlaylistItems(
        playlistContainer,
        category.playlist_categories,
        category.category_item_info
      );
      playlistsContainer.appendChild(playlistCategory);
      // Initiate newly created swiper structure
      new Swiper(playlistContainer, {
        slidesPerView: 'auto',
        spaceBetween: 16,
        cssMode: true,
        createElements: true,
        navigation: false,
        pagination: {
          enabled: true,
          clickable: true,
          dynamicBullets: true,
        },
      });
    });
  };
  renderPlaylistCategories();

  const playlistPlayer = document.querySelector('[data-name="calm_playlist"]');

  const playNextFile = (currentPlaylist, player) => {
    currentIndex++;
    if (currentIndex < currentPlaylist.length) {
      playCurrentFile(currentPlaylist);
    } else if (!playlistFinished) {
      playlistFinished = true;
      playlistPlayer.classList.add('is-selected');
      if (player.fullscreen.active) {
        player.fullscreen.exit();
      }
      enableContinueButton();
      advancePage();
    }
  };

  const loadMedia = (index, player) => {
    if (index === 0) {
      player.load();
    } else {
      player.play();
    }
  };
  document.addEventListener('completed-page', async function () {
    Wized.data.v.session_metadata = calm_meta;
    await Wized.requests.execute('complete_session');
    sessionStorage.clear();
  });

  const startSessionButton = document.querySelector('[data-name="calm_confirm_session"]');

  // start media on session ready click
  startSessionButton.addEventListener('click', async () => {
    const userFinishedPreSession = sessionStorage.getItem('finishedPreSession');

    if (userFinishedPreSession === 'true') {
      finalStartPoint.style.left = sessionStorage.getItem('finalStartPointLeft');
      finalStartPoint.style.top = sessionStorage.getItem('finalStartPointTop');
      finalStartPoint.style.zIndex = sessionStorage.getItem('finalStartPointZIndex');
      finalStartPoint.style.display = 'block';
      finalStartPoint.style.opacity = '0.40';

      finalEndPoint.style.left = sessionStorage.getItem('finalEndPointLeft');
      finalEndPoint.style.top = sessionStorage.getItem('finalEndPointTop');
      finalEndPoint.style.zIndex = sessionStorage.getItem('finalEndPointZIndex');
      finalEndPoint.style.display = 'block';
      finalEndPoint.style.opacity = '0.40';

      drawLine(finalStartPoint, finalEndPoint, finalChartLine);
      chartingSessionComplete = true;
      chartClicks = 2;

      calm_meta = JSON.parse(sessionStorage.getItem('calmMetaData'));
      endStateCategory = calm_meta.stimuli.category;
      loadPlaylist(calm_meta.stimuli.files);

    } else {
      calm_meta = {
        ...calm_meta,
        sessionType: 'Calm Session',
        stimuli: {
          endstate: 'calm',
          category: endStateCategory,
          files: selectedPlaylist.files,
          type: selectedPlaylist.playlist_type,
          name: selectedPlaylist.playlist_name,
        },
      };
      sessionStorage.setItem('calmMetaData', JSON.stringify(calm_meta));
      sessionStorage.setItem('finishedPreSession', 'true');
      sessionStorage.setItem('readyPageTabIndex', currentTabIndex);
      sessionStorage.setItem('readyPagePageIndex', currentPageIndex);
      sessionStorage.setItem('readyPageSubPageIndex', currentSubpageIndex);
    }

    if (audioPlayer.style.display !== 'none') {
      audioPlayer.play();
    }
    if (videoPlayer.style.display !== 'none') {
      videoPlayer.play();
    }
  });

  // listen for "ready" event
  document.addEventListener('ready-page', async function () {
    // previewAudioPlayer.src = '';
    // let stringCalmMeta = JSON.stringify(calm_meta);
    // sessionStorage.setItem('calmMetaData', stringCalmMeta);
    // console.log('storage', sessionStorage.getItem('calmMetaData'));
    // sessionStorage.setItem('finishedPreSession', 'true')
  });
});
